import { useNavigate } from 'react-router-dom';
import footerlogo from '../img/footer-logo.png';

const Footer = () => {
  const navigate = useNavigate();
  const handleAboutClick = () => navigate('/about');
  const handleFAQClick = () => navigate('/faq');
  const handlePrivacyClick = () => navigate('/privacy');
  const handleBase64ToImg = () => navigate('/base64-to-image-conversion');
  const HandleImgToBase64 = () => navigate('/image-to-base64-conversion');
  const handleBase64ToAscii = () => navigate('/base64-to-ascii-conversion');
  const handleAsciiToBase64 = () => navigate('/ascii-to-base64-conversion');
  const handleJsonminifier = () => navigate('/json-minifier');
  const handleXmlminifier = () => navigate('/xml-minifier');
  const handleHtmlminifier = () => navigate('/html-minifier');
  const handleCssminifier = () => navigate('/css-minifier');
  const handleJsminifier = () => navigate('/javascript-minifier');
  const handleJsontoxml = () => navigate('/json-to-xml-convertor');
  const handleXmltojson = () => navigate('/xml-to-json-convertor');
  const handleXmlformatter = () => navigate('/xml-formatter');
  const handleHtmlformatter = () => navigate('/html-formatter');
  const handleSqlformatter = () => navigate('/sql-formatter');
  const handleJsontostring = () => navigate('/json-to-string-convertor');
  const handleStringToJson = () => navigate('/string-to-json-convertor');
  const handleJsonToHtml = () => navigate('/json-to-html-convertor');
  const handleHtmlColorCodes = () => navigate('/html-color-codes');
  const handleJsonFormatter = () => navigate('/');
  const handleBlogClick = () => navigate('/blog');
  const jwtdecodeClick = () => navigate('/jwt-decode');
  // const handleHexColorClick = () => navigate('/hexcolorcode');
  // const handleBase64Click = () => navigate('/Base64Conversion');

  const navHandler = (e, path) => {
    if (e.ctrlKey || e.metaKey || e.button === 1) {
      return; // Let browser handle opening in new tab
    }
    e.preventDefault();
    navigate(path);
  };

  return (
    <div>
      <footer className="footer-area">
        <div className="footer-top ptb-70">
          <div className="container-fluid">
            <div className="row">
              {/* Logo & Description */}
              <div className="col-lg-4 col-md-12 col-sm-12 pt-30">
                <div className="footer-logo">
                  <a href="/" onClick={(e) => navHandler(e, '/')} style={{ cursor: 'pointer' }}>
                    <img src={footerlogo} alt="Footer Logo" />
                  </a>
                </div>
                <div className="textwidget white-color">
                  <p>
                    DataBeautifier is your all-in-one toolkit for formatting, converting,
                    and beautifying data effortlessly. Designed with developers in mind,
                    it streamlines complex data tasks into simple, powerful utilities.
                  </p>
                </div>
              </div>

              {/* Converter */}
              <div className="col-lg-2 col-md-12 col-sm-12 pt-30">
                <div className="footer-menu pl-50">
                  <h3 className="footer-title">Convertor</h3>
                  <ul className="site-map">
                    <li><a href="/json-to-xml-convertor" onClick={(e) => navHandler(e, '/json-to-xml-convertor')}>JSON to XML</a></li>
                    <li><a href="/xml-to-json-convertor" onClick={(e) => navHandler(e, '/xml-to-json-convertor')}>XML to JSON</a></li>
                    <li><a href="/json-to-string-convertor" onClick={(e) => navHandler(e, '/json-to-string-convertor')}>JSON to STRING</a></li>
                    <li><a href="/string-to-json-convertor" onClick={(e) => navHandler(e, '/string-to-json-convertor')}>STRING TO JSON</a></li>
                    <li><a href="/json-to-html-convertor" onClick={(e) => navHandler(e, '/json-to-html-convertor')}>JSON TO HTML</a></li>
                    <li><a href="/text-to-binary-convertor" onClick={(e) => navHandler(e, '/text-to-binary-convertor')}>Text to Binary</a></li>
                    <li><a href="/binary-to-text-convertor" onClick={(e) => navHandler(e, '/binary-to-text-convertor')}>Binary to Text</a></li>
                    <li><a href="/currency-convertor" onClick={(e) => navHandler(e, '/currency-convertor')}>Currency Convertor</a></li>
                  </ul>
                </div>
              </div>

              {/* Minifier */}
              <div className="col-lg-2 col-md-12 col-sm-12 pt-30">
                <h3 className="footer-title">Minifier</h3>
                <ul className="site-map">
                  <li><a href="/json-minifier" onClick={(e) => navHandler(e, '/json-minifier')}>JSON Minifier</a></li>
                  <li><a href="/xml-minifier" onClick={(e) => navHandler(e, '/xml-minifier')}>XML Minifier</a></li>
                  <li><a href="/html-minifier" onClick={(e) => navHandler(e, '/html-minifier')}>HTML Minifier</a></li>
                  <li><a href="/css-minifier" onClick={(e) => navHandler(e, '/css-minifier')}>CSS Minifier</a></li>
                  <li><a href="/javascript-minifier" onClick={(e) => navHandler(e, '/javascript-minifier')}>JavaScript Minifier</a></li>
                  <li><a href="/typescript-minifier" onClick={(e) => navHandler(e, '/typescript-minifier')}>TypeScript Minifier</a></li>
                  <li><a href="/sql-minifier" onClick={(e) => navHandler(e, '/sql-minifier')}>SQL Minifier</a></li>
                  <li><a href="/yaml-minifier" onClick={(e) => navHandler(e, '/yaml-minifier')}>YAML Minifier</a></li>
                </ul>
              </div>

              {/* Formatter */}
              <div className="col-lg-2 col-md-12 col-sm-12 pt-30">
                <h3 className="footer-title">Formatter</h3>
                <ul className="site-map">
                  <li><a href="/" onClick={(e) => navHandler(e, '/css-formatter')}>CSS Formatter</a></li>
                  <li><a href="/xml-formatter" onClick={(e) => navHandler(e, '/xml-formatter')}>XML Formatter</a></li>
                  <li><a href="/html-formatter" onClick={(e) => navHandler(e, '/html-formatter')}>HTML Formatter</a></li>
                  <li><a href="/sql-formatter" onClick={(e) => navHandler(e, '/sql-formatter')}>SQL Formatter</a></li>
                  <li><a href="/html-color-codes" onClick={(e) => navHandler(e, '/html-color-codes')}>HTML Color Codes</a></li>
                  <li><a href="/python-formatter" onClick={(e) => navHandler(e, '/python-formatter')}>Python Formatter</a></li>
                  <li><a href="/regex-tester" onClick={(e) => navHandler(e, '/regex-tester')}>Regex Tester & Formatter</a></li>
                  <li><a href="/typescript-formatter" onClick={(e) => navHandler(e, '/typescript-formatter')}>TypeScript Formatter</a></li>

                </ul>
              </div>

              {/* Base64 Tools */}
              <div className="col-lg-2 col-md-12 col-sm-12 pt-30">
                <h3 className="footer-title">Base 64 Tools</h3>
                <ul className="site-map">
                  <li><a href="/base64-to-image-conversion" onClick={(e) => navHandler(e, '/base64-to-image-conversion')}>Base64 To Image</a></li>
                  <li><a href="/image-to-base64-conversion" onClick={(e) => navHandler(e, '/image-to-base64-conversion')}>Image To Base64</a></li>
                  <li><a href="/base64-to-ascii-conversion" onClick={(e) => navHandler(e, '/base64-to-ascii-conversion')}>Base64 To ASCII</a></li>
                  <li><a href="/ascii-to-base64-conversion" onClick={(e) => navHandler(e, '/ascii-to-base64-conversion')}>ASCII To Base64</a></li>
                  <li><a href="/jwt-decode" onClick={(e) => navHandler(e, '/jwt-decode')}>JWT Decode</a></li>
                  <li><a href="/uuid-generator" onClick={(e) => navHandler(e, '/uuid-generator')}>UUID Generator</a></li>
                  <li><a href="/lorem-ipsum" onClick={(e) => navHandler(e, '/lorem-ipsum')}>Lorem Ipsum Generator</a></li>
                  <li><a href="/qrcode-generator" onClick={(e) => navHandler(e, '/qrcode-generator')}>QR Code Generator</a></li>

                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="container-fluid">
            <div className="row y-middle">
              <div className="col-lg-4 text-lg-end text-center order-last">
                <ul className="footer-social">
                  <li><a href="https://www.facebook.com/profile.php?id=61572346056358"><i className="fa fa-facebook"></i></a></li>
                  <li><a href="https://x.com/databeautifier"><i className="fa fa-twitter"></i></a></li>
                  <li><a href="https://www.linkedin.com/in/data-beautifier/"><i className="fa fa-linkedin"></i></a></li>
                  <li><a href="https://in.pinterest.com/beautifierdata/"><i className="fa fa-pinterest-p"></i></a></li>
                  <li><a href="https://www.instagram.com/databeautifier/"><i className="fa fa-instagram"></i></a></li>
                </ul>
              </div>
              <div className="col-lg-8">
                <div className="copyright text-lg-start text-center">
                  <p>© 2025 DB - Data Beautifier, transform your data. All Rights Reserved.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;